import { render, staticRenderFns } from "./orderInfo.vue?vue&type=template&id=416e3035&scoped=true&"
import script from "./orderInfo.js?vue&type=script&lang=js&"
export * from "./orderInfo.js?vue&type=script&lang=js&"
import style0 from "./orderInfo.css?vue&type=style&index=0&id=416e3035&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416e3035",
  null
  
)

export default component.exports